import { Roles } from '../../shared/enums';
import { AuthGuard } from '../shared/auth/guards/auth.guard';
import { RoleGuard } from '../shared/auth/guards/role.guard';

export const settingsPaths = {
	default: '',
	root: 'settings',
};

export const settingsFragments = {
	default: [settingsPaths.default],
	root: [settingsPaths.default, settingsPaths.root],
};

export const settingsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const settingsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: {
		roles: settingsDefaultAuthRoles,
	},
};
